import axios from "axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

const api = axios.create({
  baseURL: "https://hmca-api.hezee.co.in/api",
  // baseURL: "http://rkocscwc4kcoc4480480oks8.72.61.244.103.sslip.io/api",
  // baseURL: "http://127.0.0.1:8000/api",
});

api.interceptors.request.use((config) => {
  const token = Cookies.get("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Check your internet or server!",
      });
      return Promise.reject(error);
    }

    const { status, data } = error.response;
    const message = data?.message || "Unexpected error occurred";

    if (status === 401) {
      Cookies.remove("authToken");

      if (!sessionStorage.getItem("expired_notified")) {
        await Swal.fire({
          icon: "warning",
          title: "Session Expired",
          text: "Please sign in again.",
        });

        sessionStorage.setItem("expired_notified", "true");
      }

      window.location.reload();
      return Promise.reject(error);
    }

    if (status === 403) {
      Swal.fire("Access Denied", "You don't have permission.", "error");
    } else if (status === 404) {
      Swal.fire("Not Found", message, "error");
    } else if (status >= 500) {
      Swal.fire("Server Error", message, "error");
    } else {
      Swal.fire("Error", message, "error");
    }

    return Promise.reject(error);
  }
);

export default api;

export const getPropertyDetails = async (propertyId) => {
  try {
    const response = await api.get(`/property/${propertyId}`);
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch property:", error);
    throw error;
  }
};
